// Starts an OmniAuth request phase (the "Log in with Microsoft" button).
//
// Through omniauth 1.x this was a plain link: GET /auth/auth/<provider> was
// enough to begin the flow. That is exactly CVE-2015-9284 — any third-party
// page could point a victim's browser at that URL and silently start an auth
// handshake the victim never asked for. omniauth 2 closed it by allowing only
// POST on its request path, and omniauth-rails_csrf_protection additionally
// requires Rails' authenticity token on that POST.
//
// A link can no longer start the flow, so build and submit a real form. The
// login page is server-rendered through layouts/application.html.erb, which
// emits csrf_meta_tags, so the token is in the document by the time the button
// can be clicked.

// Devise mounts OmniAuth under its own `path`, which is 'auth' (see
// devise_for :users, path: 'auth'), hence the doubled segment.
const OMNIAUTH_REQUEST_PREFIX = '/auth/auth';

export const omniauthRequestPath = (provider) => `${OMNIAUTH_REQUEST_PREFIX}/${provider}`;

const csrfToken = () => document.getElementsByName('csrf-token')[0]?.content;

const hiddenInput = (name, value) => {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  return input;
};

// Returns false when the CSRF token is missing, so the caller can tell the user
// rather than submitting a form the server is guaranteed to reject.
//
// `origin` is OmniAuth's origin parameter, kept in the session until the callback. The login sends
// the printer sign-in page it is on its way to, Gibraltar's or the Medsender iOS app's ('' otherwise,
// which also replaces any left over from an abandoned sign-in): AuthController#callback and the
// failure redirect (config/initializers/omniauth.rb) carry it back as ?redirect=, so the page the
// sign-in returns to still leads there, and for the iOS app is one of its sign-in pages from its
// first, server-rendered load.
export const startOmniauthSignIn = (provider, { origin } = {}) => {
  const token = csrfToken();
  if (!token) return false;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = omniauthRequestPath(provider);

  form.appendChild(hiddenInput('authenticity_token', token));
  if (typeof origin === 'string') form.appendChild(hiddenInput('origin', origin));

  document.body.appendChild(form);
  form.submit();
  return true;
};
